import { render, staticRenderFns } from "./GameCard.vue?vue&type=template&id=02e0f07c&scoped=true"
import script from "./GameCard.vue?vue&type=script&lang=ts"
export * from "./GameCard.vue?vue&type=script&lang=ts"
import style0 from "./GameCard.vue?vue&type=style&index=0&id=02e0f07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e0f07c",
  null
  
)

export default component.exports